// PERF-15 — exponential backoff for status polling.
// Ramps the delay between status polls 2s → 4s → 8s and then caps at 8s,
// so long-running tasks stop hammering the php-fpm pool at a fixed 2s cadence.
// Pure/stateless helper shared by every task/generation status poller.
export const POLL_BACKOFF_DELAYS = [2000, 4000, 8000] as const;

/**
 * Delay (ms) to wait before the next poll, given the zero-based attempt index.
 * attempt 0 → 2000, 1 → 4000, 2 → 8000, 3+ → 8000 (capped).
 */
export const getBackoffDelay = (attempt: number): number =>
    POLL_BACKOFF_DELAYS[Math.min(Math.max(attempt, 0), POLL_BACKOFF_DELAYS.length - 1)];
